<template>
  <div>
    <el-table
      :data="userList"
      height="calc(100vh - 353px)"
      :row-class-name="tableRowClassName"
    >
      <el-table-column label="仓位ID" fixed="left" min-width="180">
        <template slot-scope="scope">{{ scope.row.positionId }}</template>
      </el-table-column>

      <el-table-column
        prop="id"
        label="用户UID"
        align="center"
        fixed="left"
        min-width="150"
      >
        <template slot-scope="scope">
          <span
            @click="showBox(scope.row, 2)"
            :class="{
              tdRed: scope.row.mark == true,
              blue: scope.row.mark != true,
              myTd: true,
            }"
            >{{ scope.row.userId }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="channelUserId"
        label="合伙人UID"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span @click="showBox(scope.row, 1)" class="myTd blue">{{
            scope.row.channelUserId
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="balanceTypeDesc"
        label="账户类型"
        align="center"
        min-width="120"
      />
      <el-table-column
        prop="userTypeDesc"
        label="用户类型"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.userTypeDesc || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="bizId" label="订单ID" align="center" min-width="180" />
      <el-table-column prop="type" label="类型" align="center" min-width="150">
        <template slot-scope="scope">
          {{ getBillTypeLabel(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="coin" label="币种" align="center" min-width="140">
        <template slot-scope="scope">
          {{ scope.row.coin }}
        </template>
      </el-table-column>
      <el-table-column prop="side" label="增减" align="center" min-width="160">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.side == 1">增加</el-tag>
          <el-tag v-else>减少</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金额"
        align="right"
        min-width="160"
      >
        <template slot-scope="scope">
          <span :class="Number(scope.row.amount || 0) >= 0 ? 'num-green' : 'num-red'">
            {{ scope.row.amount }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="before"
        label="变更前金额"
        align="right"
        min-width="160"
      >
        <template slot-scope="scope">
          <span :class="Number(scope.row.before || 0) >= 0 ? 'num-green' : 'num-red'">
            {{ scope.row.before }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="after"
        label="变更后金额"
        align="right"
        min-width="160"
      >
        <template slot-scope="scope">
          <span :class="Number(scope.row.after || 0) >= 0 ? 'num-green' : 'num-red'">
            {{ scope.row.after }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="180">
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>

    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import updateDialog from "../updatedialog";
import UserDetailDialog from "components/userDetailDialog";
import { getBillTypeLabel } from "../../constants";

export default {
  name: "UserList",
  data() {
    return {
      updateForm: {},
      type: "",
      id: "",
    };
  },
  components: {
    Pagination,
    updateDialog,
    UserDetailDialog,
  },
  methods: {
    getBillTypeLabel,
    ...mapActions("contractBill", ["addRemark"]),
    ...mapMutations("contractBill", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
    ]),
    ...mapMutations("contractassets", ["setUserDetailInfoVisible"]),
    pageChanged(pagination) {
      this.$emit("refresh", pagination);
    },
    showBox(row, type) {
      this.type = type;
      this.id = type == 2 ? row.userId : row.channelUserId;
      this.setUserDetailInfoVisible(true);
    },
    tableRowClassName({ row }) {
      if (row.mark == true) {
        return "redRow";
      }
      return "";
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    ...mapState("contractBill", [
      "pagination",
      "userList",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
    ]),
  },
};
</script>

<style lang="less" src="../../../../../styles/table.less" scoped></style>
<style lang="less" scoped>
.num-green {
  color: #67c23a;
}
.num-red {
  color: #f56c6c;
}
</style>
